<form [formGroup]="userProfileForm" (ngSubmit)="onSubmit()" id="frmProfile">
  <div class="u-background-color-white u-padding-15" id="divMainProfile">
    <div fxLayout="row wrap" fxLayoutGap="15px grid" id="divWrapMain">
      <div fxFlex="none" id="divFlexMain">
        <app-file-upload
          id="comFileUpload"
          [allowedTypes]="'image/*'"
          [imageSRC]="base64Image ? base64Image : userDetail.profilePicture"
          (uploadedFileBase64String)="setImageBase64($event)"
        >
        </app-file-upload>
      </div>
      <div fxFlex="" id="divForm">
        <div fxLayout="row wrap" fxLayoutGap="15px grid" fxLayoutAlign="start end" id="divForm2">
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20" id="divForm3">
            <mat-form-field class="mat-block" id="matFrmUsername">
              <input
                matInput
                id="txtUserName"
                [placeholder]="'profile.user_name' | translate"
                formControlName="userName"
              />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="15px grid" fxLayoutAlign="start end">
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
            <mat-form-field class="mat-block" id="matFrmfirstname">
              <input
                matInput
                id="txtFirstname"
                formControlName="firstName"
                [placeholder]="'profile.first_name' | translate"
                required
              />
              <mat-error
                class="error-message"
                id="matErrorFirstnameRequired"
                *ngIf="userProfileForm.get('firstName').dirty || userProfileForm.get('firstName').touched"
              >
                {{ "profile.firstname_validation" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
            <mat-form-field class="mat-block" id="matFrmMiddleName">
              <input
                matInput
                id="txtMiddlename"
                formControlName="middleName"
                [placeholder]="'profile.middle_name' | translate"
              />
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
            <mat-form-field class="mat-block" id="matFrmLastName">
              <input
                matInput
                id="txtFirstname"
                formControlName="lastName"
                [placeholder]="'profile.last_name' | translate"
                required
              />
              <mat-error
                class="error-message"
                id="matErrorLastnameRequired"
                *ngIf="userProfileForm.get('lastName').dirty || userProfileForm.get('lastName').touched"
              >
                {{ "profile.lastname_validation" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
            <mat-form-field class="mat-block" id="matFrmDOB">
              <input
                matInput
                id="txtDOB"
                formControlName="dateOfBirth"
                [matDatepicker]="picker"
                [placeholder]="'profile.date_of_birth' | translate"
              />
              <mat-datepicker-toggle
                id="dtPickerDOB"
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error
                class="error-message"
                id="matErrorDOBRequired"
                *ngIf="userProfileForm.get('dateOfBirth').dirty || userProfileForm.get('dateOfBirth').touched"
              >
                {{ "profile.dob_validation" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
            <mat-form-field id="matFrmFieldCountryCode" fxFlex="40">
              <mat-select
                id="matSelectCountryCode"
                formControlName="countryCode"
                (selectionChange)="getCountryCodeValue()"
                [placeholder]="'profile.country_code' | translate"
              >
                <mat-select-trigger id="matSelectTriggerCountryCode">
                  {{selectedCountryCode}}
                </mat-select-trigger>
                <mat-option
                  id="matOptionCountryCode"
                  *ngFor="let country of countryList"
                  [value]="country.country_code"
                >
                  {{ country.name + ' (' + country.country_code + ')'}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="mat-block" id="matFrmPhoneNumber" fxFlex="60">
              <input
                matInput
                id="txtPhoneNumber"
                formControlName="phoneNumber"
                type="number"
                [placeholder]="'profile.phone_number' | translate"
              />
              <mat-error
                class="error-message"
                id="matErrorInvalidPhoneNumber"
                *ngIf="(userProfileForm.get('phoneNumber').dirty || userProfileForm.get('phoneNumber').touched) &&
                             (userProfileForm.get('phoneNumber').hasError('min') || userProfileForm.get('phoneNumber').hasError('max'))"
              >
                {{ "profile.phonenumber_validation" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
            <mat-form-field class="mat-block" id="matFrmEmailId">
              <input
                matInput
                type="email"
                id="txtEmailId"
                formControlName="emailId"
                [placeholder]="'profile.email_id' | translate"
                required
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="15px grid" id="divRecentActivity">
      <!-- <div fxFlex="none">
        <h3 id="h3RecentActivity" class="u-padding-top-20" style="width: 170px;">
          {{ "profile.recent_activity" | translate }}
        </h3>
        <div
          fxLayout="row wrap"
          style="height: 91%; border: 1px solid;"
          fxLayoutGap="15px grid"
        ></div>
      </div> -->
      <div fxFlex="">
        <div fxLayout="row wrap" fxLayoutGap="15px grid">
          <div fxFlex="">
            <div fxLayout="row wrap" fxLayoutGap="15px grid" fxLayoutAlign="start end">
              <div fxFlex="50">
                <mat-form-field
                  class="mat-block"
                  fxFlex.gt-sm="100"
                  fxFlex.gt-md="100"
                  id="matFrmStreet1"
                >
                  <input
                    id="txtStreet1"
                    matInput
                    type="text"
                    formControlName="street1"
                    [placeholder]="'profile.street1' | translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field
                  class="mat-block"
                  fxFlex.gt-sm="100"
                  fxFlex.gt-md="100"
                  id="matFrmStreet2"
                >
                  <input
                    matInput
                    id="txtStreet2"
                    type="text"
                    formControlName="street2"
                    [placeholder]="'profile.street2' | translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.gt-md="20">
                <mat-form-field class="mat-block" id="matFrmCountry">
                  <mat-select
                    id="matSelectCountry"
                    [placeholder]="'profile.country' | translate"
                    formControlName="country"
                    required
                  >
                    <mat-option *ngFor="let country of countryList" [value]="country"
                      >{{country.name}}</mat-option
                    >
                  </mat-select>
                  <mat-error
                    id="matCountryRequired"
                    class="error-message"
                    *ngIf="
                    userProfileForm.get('country').dirty ||
                    userProfileForm.get('country').touched"
                  >
                    {{ "profile.country_validation_err" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.gt-md="20">
                <mat-form-field class="mat-block" id="matFrmCity">
                  <input
                    matInput
                    id="matCity"
                    formControlName="city"
                    [placeholder]="'profile.city' | translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" id="matPostCode" fxFlex.gt-sm="25" fxFlex.gt-md="20">
                <mat-form-field class="mat-block" id="matFrmPostcode">
                  <input
                    matInput
                    type="text"
                    [placeholder]="'profile.postcode' | translate"
                    formControlName="postcode"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.gt-md="20">
                <mat-form-field class="mat-block" id="matFrmUserRole">
                  <input
                    matInput
                    id="matUserRole"
                    formControlName="userRole"
                    [placeholder]="'profile.user_role' | translate"
                    required
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.gt-md="20">
                <mat-form-field class="mat-block" id="matFrmLanguage">
                  <mat-select
                    id="matSelectLanguage"
                    [placeholder]="'profile.language' | translate"
                    formControlName="language"
                  >
                    <mat-option *ngFor="let language of languageList" [value]="language">
                      {{ language.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.gt-md="40">
                <app-timezone-dropdown
                  id="timeZoneDropDown"
                  [ctrl]="userProfileForm.get('timeZone')"
                  [placeholder]="'profile.timezone' | translate"
                  [isOverriden]="false"
                >
                </app-timezone-dropdown>
              </div>
            </div>
          </div>
        </div>

        <!-- <h3 class="u-padding-top-20">{{ "profile.communication_preference" | translate }}</h3>
        <div fxLayout="row center" fxLayoutGap="15px grid">
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="33" fxFlex.gt-lg="20">
            <mat-checkbox formControlName="communicationEmail" id="matCbkEmail">
              <label id="lblEmail">{{ "profile.email" | translate }}</label>
            </mat-checkbox>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="33" fxFlex.gt-lg="20">
            <mat-checkbox formControlName="communicationSms" id="matCbkSMS">
              <label id="lblSMS">{{ "profile.sms" | translate }}</label>
            </mat-checkbox>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="33" fxFlex.gt-lg="20">
            <mat-checkbox formControlName="communicationPush" id="matCbkPush">
              <label id="lblPush">{{ "profile.push_notification" | translate }}</label>
            </mat-checkbox>
          </div>
        </div> -->

        <!-- <h3 class="u-padding-top-20" id="h3ApprovalStatus">
          {{ "profile.approval_status" | translate }}
        </h3>
        <div
          fxLayout="row wrap"
          style="height: 300px; border: 1px solid;"
          fxLayoutGap="15px grid"
        ></div> -->
      </div>
    </div>
  </div>
  <div class="c-bottom-action-bar u-text-right">
    <button
      mat-flat-button
      color="primary"
      id="btnSave"
      [disabled]="userProfileForm.invalid||!isAnyValueUpdated"
    >
      {{ "profile.save" | translate }}
    </button>
    <button mat-flat-button color="warn" type="button" (click)="cancel()" id="btnCancel">
      {{ "profile.cancel" | translate }}
    </button>
  </div>
</form>
